<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <b-button
          :disabled="!whatClerkPermission"
          variant="primary"
          @click="$refs.freightModal.toggleOpen({ rulesData: null })"
        >
          <i class="fas fa-plus mr-1"></i>
          Adicionar regra {{ 
            typeFreightTransport === TypeFreightTransport.EXCLUSIVE_TRUCK ? 
              'exclusiva para caminhão': 'para frete normal' 
          }}
        </b-button>
      </b-col>

      <b-col cols="12" v-if="rulesFreight.length > 0" class="mt-3">
        <b-table striped hover :items="rulesFreight" :fields="fields">
          <template #cell(actions)="row">
            <b-button 
              variant="danger" 
              @click="removeRule(row.item.id)"
              :disabled="rulesFreight.length - 1  !== row.index"
            >
              <i class="fas fa-trash"></i>
            </b-button>
            <!-- Deixei comentado para ajustar a regra de atualização no futuro -->
            <!-- <b-button class="ml-2" variant="primary" @click="$refs.freightModal.toggleOpen({ rulesData: row.item })">
              <i class="fas fa-edit"></i>
            </b-button> -->
          </template>

          <template #cell(type)="data">
            {{ getTypeFreight(data.item.type_transport) }}
          </template>

          <template #cell(value)="data">
            {{ formatMoneyUn(data.item.value) }}
          </template>
        </b-table>
      </b-col> 
      <FreightModal
        ref="freightModal"
        @save="save($event)"
        @update="editRule($event)"
        :lastRuleKm="getLastKm()"
      />
    </b-row>
  </b-card>
</template>

<script>
import FreightModal from '@/components/Freight/FreightModal.vue';
import TypeFreight from '@/enums/TypeFreight';
import { formatMoney } from '@/utils/number';
import { mapActions, mapGetters, mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
import TypeFreightTransport from '@/enums/TypeFreightTransport';

export default {
  name: 'FreighRulesComponent',
  mixins: [makeToast],
  emits: ['getRules'],
  
  components: {
    FreightModal,
  },

  props: {
    whatClerkPermission: {
      type: Boolean,
      required: true,
    },
    shopkeeperId: {
      type: Number,
      required: true,
    },
    rulesFreight: {
      type: Array,
      required: true,
      default: []
    },
    typeFreightTransport: {
      type: Number,
      required: true,
      default: 1
    },
    idTypeFreight: {
      type: Number,
      required: true,
      default: 1
    }
  },
  data() {
    return {
      TypeFreight,
      TypeFreightTransport,
      loading: false,
      fields: [
        { key: 'type', label: 'Tipo' },
        { key: 'km_initial', label: 'Km Inicial' },
        { key: 'km_final', label: 'Km Final' },
        { key: 'value', label: 'Valor' },
        { key: 'actions', label: 'Ações' },
      ],
    };
  },
  methods: {
    ...mapActions('shopkeeper', 
      [
        'addFreightRule',
        'updateFreightRule',
        'deleteFreightRule'
      ]
    ),
    save(event) {
      const data = {
        'construp_user_id': this.shopkeeperId,
        'type_transport': event.type,
        'shipping_rule_type_id': this.idTypeFreight,
        'value': event.value,
        'km_initial': event.km_initial,
        'km_final': event.km_final,
      }

      this.$store.dispatch('startLoader');
      this.loading = true;

      this.addFreightRule(data)
        .then((response) => {  
          if(!response.data.data.error) {
            this.makeToast(
              'Sucesso',
              'Houve um erro ao salvar os dados, tente novamente!',
              'success'
            );
            
            this.$emit('getRules');
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao salvar os dados, tente novamente!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    editRule(event) {
      const data = {
        'construp_user_id': this.shopkeeperId,
        'type_transport': event.type,
        'shipping_rule_type_id': this.idTypeFreight,
        'value': event.value,
        'km_initial': event.km_initial,
        'km_final': event.km_final,
      }

      this.$store.dispatch('startLoader');
      this.loading = true;

      this.updateFreightRule(this.shopkeeperId)
        .then((response) => {
          if(!response.data.data.error) {
            this.makeToast(
              'Sucesso',
              'Houve um erro ao salvar os dados, tente novamente!',
              'success'
            );
            
            this.$emit('getRules');
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao atualizar os dados, tente novamente',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    removeRule(ruleId) {
      this.$store.dispatch('startLoader');
      this.loading = true;

      const data = {
        'id': ruleId,
        'construpUserId': this.shopkeeperId,
      };

      this.deleteFreightRule(data)
        .then((response) => {
          if(!response.data.data.error) {
            this.makeToast(
              'Sucesso',
              'Houve um erro ao salvar os dados, tente novamente!',
              'success'
            );
            
            this.$emit('getRules');
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao apagar a regra, tente novamente!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    formatMoneyUn(value) {
      return formatMoney(value);
    },
    getLastKm() {
      if(this.rulesFreight.length == 0) return 0
      
      const last = this.rulesFreight.length - 1
      
      return this.rulesFreight[last].km_final;
    },
    getTypeFreight(type) {
      if(type === TypeFreight.FIXED) return 'Fixo';
      if(type === TypeFreight.FREE) return 'Grátis';
      if(type === TypeFreight.KM) return 'Km';
    }
  },
};
</script>
